import { EmptyState, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import unsupportedQuerySVG from './assets/unsupported-query.svg'
import messages from './messages'

export const GlobalSearchUnsupportedQueryState = () => {
  const intl = useProcurifyIntl()

  return (
    <EmptyState
      context='404'
      imgUrl={unsupportedQuerySVG}
      header={intl.formatMessage(messages.header)}
      content={<Text>{intl.formatMessage(messages.content)}</Text>}
    />
  )
}
